export const validateQueryCreate = (data = {}) => {
  const errors = {};

  /*
  |--------------------------------------------------------------------------
  | NAME
  |--------------------------------------------------------------------------
  */

  if (
    !data.name ||
    typeof data.name !== "string" ||
    !data.name.trim()
  ) {
    errors.name = "Name is required";
  } else if (
    data.name.trim().length > 150
  ) {
    errors.name =
      "Name must not exceed 150 characters";
  }


  /*
  |--------------------------------------------------------------------------
  | EMAIL
  |--------------------------------------------------------------------------
  */

  if (
    !data.email ||
    typeof data.email !== "string" ||
    !data.email.trim()
  ) {
    errors.email = "Email is required";
  } else if (
    !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(
      data.email.trim()
    )
  ) {
    errors.email = "Invalid email address";
  }


  /*
  |--------------------------------------------------------------------------
  | PHONE
  |--------------------------------------------------------------------------
  */

  if (
    data.phone &&
    String(data.phone).trim().length > 30
  ) {
    errors.phone =
      "Phone must not exceed 30 characters";
  }


  /*
  |--------------------------------------------------------------------------
  | COMPANY
  |--------------------------------------------------------------------------
  */

  if (
    data.companyName &&
    String(data.companyName).trim().length > 200
  ) {
    errors.companyName =
      "Company name must not exceed 200 characters";
  }


  /*
  |--------------------------------------------------------------------------
  | SUBJECT
  |--------------------------------------------------------------------------
  */

  if (
    data.subject &&
    String(data.subject).trim().length > 250
  ) {
    errors.subject =
      "Subject must not exceed 250 characters";
  }


  /*
  |--------------------------------------------------------------------------
  | MESSAGE
  |--------------------------------------------------------------------------
  */

  if (
    !data.message ||
    typeof data.message !== "string" ||
    !data.message.trim()
  ) {
    errors.message = "Message is required";
  }


  return errors;
};


export const validateQueryUpdate = (data = {}) => {
  const errors = {};


  if (
    data.subject !== undefined &&
    data.subject !== null &&
    String(data.subject).trim().length > 250
  ) {
    errors.subject =
      "Subject must not exceed 250 characters";
  }


  if (
    data.message !== undefined &&
    (
      typeof data.message !== "string" ||
      !data.message.trim()
    )
  ) {
    errors.message =
      "Message cannot be empty";
  }


  return errors;
};


export const hasValidationErrors = (
  errors
) => {
  return Object.keys(errors).length > 0;
};